import { useEffect } from "react";

interface SizeGuideModalProps {
  open: boolean;
  onClose: () => void;
}

const sizeData = [
  { size: "M", bust: "38", length: "44" },
  { size: "L", bust: "40", length: "44" },
  { size: "XL", bust: "42", length: "45" },
  { size: "XXL", bust: "44", length: "45" },
];

export default function SizeGuideModal({ open, onClose }: SizeGuideModalProps) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-background-50 rounded-2xl shadow-lg max-w-md w-full p-6 md:p-8 animate-slide-up">
        <div className="flex items-center justify-between mb-6">
          <h3 className="font-heading text-xl md:text-2xl font-bold text-accent-800">
            Size Guide
          </h3>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
            aria-label="Close size guide"
          >
            <i className="ri-close-line w-5 h-5 flex items-center justify-center text-foreground-600" />
          </button>
        </div>

        <div className="overflow-hidden rounded-xl border border-background-200 mb-5">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-3 font-semibold text-accent-800">
                  Size
                </th>
                <th className="text-left px-5 py-3 font-semibold text-accent-800">
                  Bust (in)
                </th>
                <th className="text-left px-5 py-3 font-semibold text-accent-800">
                  Length (in)
                </th>
              </tr>
            </thead>
            <tbody>
              {sizeData.map((row, i) => (
                <tr
                  key={row.size}
                  className={i % 2 === 0 ? "bg-background-50" : "bg-background-100"}
                >
                  <td className="px-5 py-3 font-medium text-foreground-800">
                    {row.size}
                  </td>
                  <td className="px-5 py-3 text-foreground-600">{row.bust}</td>
                  <td className="px-5 py-3 text-foreground-600">{row.length}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-xs text-foreground-500 leading-relaxed">
          Measurements are approximate. For help choosing, message us on WhatsApp.
        </p>
      </div>
    </div>
  );
}